import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const SYSRapportMeny: IRapportInfo[] = [];

export default SYSRapportMeny;
